export default {
    stage_coding: [
      { value: 1001, label: "AJCC IV C & D", color: "#009900", show: true },
      { value: 1002, label: "else", color: "#C0C0C0", show: true },
    ],
    response: [
      // { value: 2001, label: "discovery", color: "#1E88E5", show: true },
      { value: 2001, label: "R", labelShown: 'Response' ,color: "#0000FF", show: true },
      { value: 2002, label: "NR", labelShown: 'Non-response' ,color: "#FF0000", show: true },
      { value: 2003, label: "NaN", color: "#000000", show: true },
    ],
    cohort: [
      { value: 1001, label: "discovery", color: "#FF0000", show: true },
      { value: 1002, label: "validation", color: "#00FF00", show: true },
    ],
    // tumorClass: [
    //   { value: 3001, label: "ccRCC", color: "#29ECEA", show: true },
    //   { value: 3002, label: "AML", color: "#F7CBAD", show: true },
    //   { value: 3003, label: "BHD", color: "#F3B084", show: true },
    //   { value: 3004, label: "ChRCC", color: "#CB93FF", show: true },
    //   { value: 3005, label: "ESCRCC", color: "#BE9004", show: true },
    //   { value: 3006, label: "MEST", color: "#005A9C", show: true },
    //   { value: 3007, label: "MTOR Mutated RCC", color: "#C45613", show: true },
    //   { value: 3008, label: "MTSCC-variant", color: "#FEC108", show: true },
    //   { value: 3009, label: "ND", color: "#056608", show: true },
    //   { value: 3010, label: "Oncocytoma type1", color: "#FEC9FF", show: true },
    //   { value: 3011, label: "Oncocytoma type2", color: "#FD91FF", show: true },
    //   { value: 3012, label: "Oncocytoma variant", color: "#FC53FF", show: true },
    //   { value: 3013, label: "PRCC", color: "#F7FB9F", show: true },
    //   { value: 3014, label: "PRCC type1", color: "#FFFF0B", show: true },
    //   { value: 3015, label: "PUC", color: "#4A0D4B", show: true },
    //   { value: 3016, label: "TRCC", color: "#FFE799", show: true },
    //   { value: 3017, label: "unRCC", color: "#DC143C", show: true },
    // ],
    age_group: [
      { value: 4001, label: "<50.0 (25%)", color: "#EEEEEE", show: true },
      { value: 4002, label: "50.0-58.0 (25%-50%)", color: "#CCBBAA", show: true },
      { value: 4003, label: "58.0-68.0 (50%-75%)", color: "#997755", show: true },
      { value: 4004, label: ">68.0 (>75%)", color: "#663300", show: true },
    ],
    sex: [
        { value: 5001, label: "Female", color: "#FF82AB", show: true },
        { value: 5002, label: "Male", color: "#008B00", show: true },
    ],
    ethnicity: [
      { value: 6001, label: "Caucasian", color: "#FF33FF", show: true },
      {
        value: 6002,
        label: "non-Caucasian",
        color: "#30FF3E",
        show: true,
      },
      { value: 6005, label: "Hispanic", color: "#00BFFF", show: true },
      { value: 6004, label: "African-American", color: "purple", show: true },
    ],
    "AJCC Stage": [
      { value: 7001, label: "AJCC III (includes B/C/D)", color: "#C0C0C0", show: true },
      { value: 7002, label: "AJCC IV-A", color: "#FF8000", show: true },
      { value: 7003, label: "AJCC IV-B", color: "#FF007F", show: true },
      { value: 7004, label: "AJCC IV-C", color: "#FF0000", show: true },
      { value: 7005, label: "AJCC IV-D", color: "#009900", show: true },
    ],
    Biopsy_site_tissue: [
      { value: 8001, label: "skin", color: "#8B4513", show: true },
      { value: 8002, label: "lung", color: "#FFB90F", show: true },
      { value: 8003, label: "LN", color: "#FF00FF", show: true },
    ],
    'Progression-free survival event': [
      { value: 9001, label: "Y", color: "#000000", show: true },
      { value: 9002, label: "N", color: "#EEEEEE", show: true },
    ],
    'Progression-free survival days': [
      { value: 10003, label: "<102 days (25%)", color: "#EEEEEE", show: true },
      { value: 10001, label: "102-293 days (25%-50%)", color: "#DDAAAA", show: true },
      { value: 10002, label: "293-1604 days (50%-75%)", color: "#BB5555", show: true },
      { value: 10004, label: ">1604 days (>75%)", color: "#990000", show: true },
    ],
    // "FFPE Sample Type": [
    //   { value: 11003, label: "slides", color: "#0080FF", show: true },
    //   {
    //     value: 11001,
    //     label: "gross dissection",
    //     color: "#660066",
    //     show: true,
    //   },
    //   {
    //     value: 11002,
    //     label: "punch",
    //     color: "#66CC00",
    //     show: true,
    //   },
    //   // { value: 11004, label: ">=104.5 (>75%)", color: "#1B4332", show: true },
    // ],
    ICI_cluster: [
      { value: 32001, label: "EMT-like", color: "#D81B60", show: true },
      { value: 32002, label: "ICI-sensitive", color: "#1E88E5", show: true },
      { value: 32003, label: "Ribo-high", color: "#FFC107", show: true },
    ],
    Study_Site: [
      { value: 12010, label: "GE", color: "#4C9900", show: true },
      { value: 12001, label: "MIA", color: "#CCCC00", show: true },
      { value: 12002, label: "MDACC", color: "#00CC66", show: true },
      { value: 12003, label: "MGH", color: "#0066CC", show: true },
      { value: 12004, label: "MSK", color: "#009999", show: true },
      { value: 12005, label: "NY", color: "#00NY00", show: true },
      { value: 12006, label: "POL", color: "#CC0066", show: true },
      { value: 12007, label: "UM", color: "#00CC66", show: true },
      { value: 12008, label: "UPENN", color: "#990099", show: true },
      { value: 12009, label: "UPITT", color: "#663300", show: true },
      { value: 12011, label: "VAND", color: "#330033", show: true },
      { value: 12012, label: "YALE", color: "#660000", show: true },
        // { value: 12012, label: "YALE", color: "#660000", show: true },
    ],
    TERT: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    BRAF: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    NRAS: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    NF1: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    ARID2: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
  };
  